import useMonolithApiQuery, { UseMonolithApiQueryOptions } from '@/hooks/api/useMonolithApiQuery';
import { SimpleErrorResponse } from '@/models/Error';
import { HtmlReport } from '@/models/HtmlReport';
import { getBuildHtmlReportsPath } from '@/utils/monolithApiRouteService';

export type UseBuildHtmlReportsProps = {
  buildSlug: string;
  excludeCategory?: string;
  options?: UseMonolithApiQueryOptions<HtmlReport[], SimpleErrorResponse>;
};

const useBuildHtmlReports = ({ buildSlug, excludeCategory, options }: UseBuildHtmlReportsProps) => {
  const url = getBuildHtmlReportsPath(buildSlug);
  const params = { ...options?.requestConfig?.params, exclude_category: excludeCategory };

  return useMonolithApiQuery<HtmlReport[], SimpleErrorResponse>([url, params], url, {
    ...options,
    requestConfig: {
      ...options?.requestConfig,
      params,
    },
  });
};

export default useBuildHtmlReports;
